module.exports = __webpack_public_path__ + "static/media/5_6.a845ff27.png";